import { ActionReducerMapBuilder, createSlice, Draft, PayloadAction } from "@reduxjs/toolkit";
import { IRequestState } from "../request.state.interface";
import getWorkHandler, { IWorkProp } from "./get-work.handler";
import convertEnegryHandler from "./convert-enegry.handler";
import upgradeWorkHandler from "./upgrade-handler";

export interface IWorkState extends IRequestState {
    capacity: IWorkProp | null;
    storeSpeed: IWorkProp | null;
    profitRate: IWorkProp | null;

    lastConvertDate: number;
    profit: number;
    /** Баланс до запроса convert-energy; для анимации при updatedBalance в интерцепторе */
    balanceAnimationBase: number | null;
    /** Итоговый баланс из ответа (все начисления с ответа); финальный кадр анимации */
    balanceAnimationTarget: number | null;
    currentEvergy: number;
};

const initialState: IWorkState = {
    capacity: null,
    storeSpeed: null,
    profitRate: null,

    lastConvertDate: 0,
    profit: 0,
    balanceAnimationBase: null,
    balanceAnimationTarget: null,
    currentEvergy: 0,

    loading: false,
    error: "",
};

const workSlice = createSlice({
    name: 'work',
    initialState,
    reducers: {
        resetProfit: (state: Draft<IWorkState>) => {
            state.profit = 0;
            state.balanceAnimationBase = null;
            state.balanceAnimationTarget = null;
        },
        updateCurrentEnergy: (state: IWorkState, action: PayloadAction<number>) => {
            state.currentEvergy = action.payload;
        },
    },
    extraReducers: (builder: ActionReducerMapBuilder<IWorkState>) => {
        getWorkHandler(builder);
        convertEnegryHandler(builder);
        upgradeWorkHandler(builder);
    },
});

export const { resetProfit, updateCurrentEnergy } = workSlice.actions;
export default workSlice.reducer;